import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddCourse, successaddCourse } from "./AddCourseSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ICourse } from "../../../Pages/Subject/ICourse";

import {
  failuredeleteCourse,
  successdeleteCourse,
} from "./DeleteCourseSlice";
import { failurelistCourse, successlistCourse } from "./ListCourseSlice";
import { failureEditCourse, successEditCourse } from "./EditCourseSlice";

// list
const ListCourseApi = () => {
  return api.get("/api/course/");
};

export function* ListCourseCall() {
  try {
    const response: AxiosResponse = yield call(ListCourseApi);
    yield put(successlistCourse(response.data));
  } catch (error) {
    yield put(failurelistCourse(error));
  }
}

// add
const AddCourseApi = (action: PayloadAction<ICourse>) => {
  return api.post("/api/course/create_edit", { ...action.payload, is_delete: false });
};

export function* AddCourseCall(action: PayloadAction<ICourse>) {
  try {
    const response: AxiosResponse = yield call(AddCourseApi, action);
    yield put(successaddCourse(response.data));
  } catch (error) {
    yield put(failureaddCourse(error));
  }
}

// edit
const EditCourseApi = (action: PayloadAction<ICourse>) => {
  return api.post("/api/course/create_edit", action.payload);
};

export function* EditCourseCall(action: PayloadAction<ICourse>) {
  try {
    const response: AxiosResponse = yield call(EditCourseApi, action);
    yield put(successEditCourse(response.data));
  } catch (error) {
    yield put(failureEditCourse(error));
  }
}

// delete
const DeleteCourseApi = (action: PayloadAction<number>) => {
  return api.post("/api/course/create_edit", { id: action.payload, is_delete: true });
};

export function* DeleteCourseCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteCourseApi, action);
    yield put(successdeleteCourse(response.data));
  } catch (error) {
    yield put(failuredeleteCourse(error));
  }
}
